export const ARC_EXTENSION_LENGTH = 0.025;
export const ARC_THICKNESS = 10;
export const CLASS_NAME = 'data-point';
export const CLASS_NAME_TARGET = 'data-point-target-of';
export const FONT_SIZE = 13;
export const GROUP_PAD_ANGLE = 0.12;
export const LINE_HEIGHT = 20;
export const MARKER_HEIGHT = LINE_HEIGHT;
export const MARKER_WIDTH = LINE_HEIGHT * 0.5;
export const MARKER_RADIUS = MARKER_WIDTH * 0.5;
export const MARKER_DISTANCE_FROM_WHEEL = LINE_HEIGHT;
export const RIBBON_OPACITY = '0.75';
export const WHEEL_WIDTH = 700;
export const WHEEL_HEIGHT = 400;
export const WHEEL_RADIUS = WHEEL_HEIGHT * 0.35;
